import { render, staticRenderFns } from "./regisStuForSet.vue?vue&type=template&id=029b8a6c&"
import script from "./regisStuForSet.vue?vue&type=script&lang=js&"
export * from "./regisStuForSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports